import moment from 'moment'

export const logError = err => {
  // eslint-disable-next-line no-console
  console.log(
    '%cErrors:',
    'background: red; color: white; border-radius: 2px; padding: 2px;',
    err.response.data
  )
}

export const arrSum = function(arr) {
  return arr.reduce(function(a, b) {
    return a + b
  }, 0)
}

export const sendGTMEvent = function(event) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(event)

  if (window.location.host.match(/localhost|staging/g)) {
    var style =
      'color:white; background-color:blue; border-radius: 5px; padding:2px'
    // eslint-disable-next-line no-console
    console.info(
      '%c > ' + (event.event ? event.event : 'N/A') + ': ',
      style,
      event
    )
  }
}

export const monthNames = function(locale, short = false) {
  let months = []
  let format = short ? 'MMM' : 'MMMM'
  let m = moment().locale(locale)
  for (let i = 0; i < 12; i++) {
    months.push(m.month(i).format(format))
  }
  return months
}
